<script>
import headers from '@src/data/headers.json'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  props: {
    propertyId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headers: headers.point,
      items: [],
      color: 'gold',
      deleteDialog: false,
      deleteId: null,
    }
  },

  computed: {
    tableHeaders() {
      const th = this.headers.slice(0)
      th.push({ text: 'Actions', sortable: false, align: 'right' })
      return th
    },
  },

  mounted() {
    this.fetchItems()
  },

  methods: {
    async fetchItems() {
      this.items = await this.fetchData({
        url: this.endpoint.point.list,
        data: { propertyId: this.propertyId },
      })
    },
    emitEvent(item = {}) {
      this.$emit('event', { currentView: 'PointDetail', item })
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    closeDialog() {
      this.deleteDialog = false
      this.deleteId = null
    },
    async onDelete() {
      await this.updateData({
        url: this.endpoint.delete,
        data: {
          id: this.deleteId,
          propertyId: this.propertyId,
        },
      })
      this.fetchItems()
      this.closeDialog()
    },
  },
}
</script>

<template>
  <BaseView title="Point" color="gold">
    <!-- Slot toolbar-actions -->
    <VBtn
      slot="toolbar-actions"
      color="gold"
      depressed
      dark
      @click="emitEvent()"
    >
      Add
    </VBtn>
    <!-- End of Slot toolbar-actions -->

    <VDataTable
      :headers="tableHeaders"
      :items="items"
      :loading="loading ? color : false"
      hide-actions
    >
      <!-- Item Slot -->
      <template slot="items" slot-scope="props">
        <td
          v-for="(header, index) in headers"
          :key="`${header.text}-${index}`"
          :class="{ 'text-xs-right': header.align && header.align === 'right' }"
        >
          {{ props.item[header.value] }}
        </td>
        <td class="text-xs-right">
          <!-- Edit Icon -->
          <VIcon small class="mr-2" @click="emitEvent(props.item)">
            edit
          </VIcon>
          <!-- End of Edit Icon -->

          <!-- Delete Icon -->
          <VIcon small @click="deleteItem(props.item)">
            delete
          </VIcon>
          <!-- End of Delete Icon -->
        </td>
      </template>
      <!-- End of Item Slot -->
    </VDataTable>

    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete entry</VCardTitle>

        <VCardText>Are you sure want to delete this entry?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">
            Cancel
          </VBtn>

          <VBtn color="gold" flat @click="onDelete">
            Delete
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </BaseView>
</template>
